import {ON_ROLES_LIST,ON_ROLES_ADD} from '../constants/ActionTypes';

const INIT_STATE = {
    rolesList: [],
    roleObj:{}
};


export default (state=INIT_STATE,action) => {
    switch (action.type){

        case ON_ROLES_LIST: {
            return {...state, rolesList: action.payload};
        }
        case ON_ROLES_ADD: {
            return { ...state, roleObj: action.payload };
        }
        default:
            return state;
    }
}